import { Injectable } from "@angular/core";
import { CommonService } from "../common.service";

export interface Menu {
  state: string;
  name: string;
  type: string;
  iconUrl: string;
  iconUrlActive: string;
}

const MENUITEMS = [
  {
    state: "home",
    name: "Home",
    type: "link",
    iconUrl: "assets/images/home_off.svg",
    iconUrlActive: "assets/images/home_on.svg",
    access: "admin",
  },
  // {
  //   state: "application",
  //   name: "Application",
  //   type: "link",
  //   iconUrl: "assets/images/list.png",
  //   iconUrlActive: "assets/images/list.png",
  //   access: "admin",
  // },
  {
    state: "logout",
    name: "Logout",
    type: "logout",
    iconUrl: "assets/images/logout_off.svg",
    iconUrlActive: "assets/images/logout_on.svg",
    access: "admin",
  },
  
  
  // {
  //   state: "note-management",
  //   name: "Note List",
  //   type: "link",
  //   iconUrl: "assets/images/ic_note_active.svg",
  //   iconUrlActive: "assets/images/ic_note.svg",
  //   access: "admin",
  // },
];

@Injectable()
export class MenuItems {
  constructor(private commonService: CommonService) {}
  getMenuitem(): Menu[] {
    const menuItems = MENUITEMS;
    menuItems.forEach((element) => {
      element["show"] ="W";
    });
    return menuItems;
  }
}
